import React, { Fragment } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Grid, Paper } from "@material-ui/core";

import BannerCelfocus from '../../assets/BannerCelfocus.jpg';
import constants from '../../main/constants';
import Search from '../../containers/Search/Search';
import Footer from '../../containers/Footer';

import Omnichannel from '../Sections/Omnichannel';
import ESignComponent from '../Sections/ESignComponent';
import OrderManagement from '../Sections/OrderManagement';
import ProductCatalogue from '../Sections/ProductCatalogue';

const useStyles = makeStyles(() => ({
    root: {
        flexGrow: 1,
        margin: 'auto',
        display: 'flex',
        outline: 0,
        position: 'relative',
        justifyContent: 'center',
        width: '100%'
    },
    grid: {
        height: 330,
        backgroundImage: `url(${BannerCelfocus})`,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center center",
        backgroundSize: "cover"
    },
    paper: {
        height: '100%',
        maxWidth: 500,
        width:450,
        borderRadius: 20
    },
    paperSubscription: {
        backgroundColor: '#f5f5f5',
        borderRadius: 20
    }
}));

export const Start = ({ page, setPage }) => {
    const classes = useStyles();

    return (
        <Fragment>
            <div className={classes.grid}>
                <Search type={constants.SEARCH_MAIN} page={page} setPage={setPage} />
                <Grid container className={classes.root} spacing={4}>
                    <Grid item xs={12}>
                        <Grid container justify="center" spacing={4}>
                            <Grid item>
                                <Paper className={classes.paper}>
                                    <ESignComponent setPage={setPage} />
                                </Paper>
                            </Grid>
                            <Grid item>
                                <Paper className={classes.paper}>
                                    <Omnichannel setPage={setPage} />
                                </Paper>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12}>
                        <Grid container justify="center" spacing={4}>
                            <Grid item>
                                <Paper className={classes.paper}>
                                    <OrderManagement setPage={setPage} />
                                </Paper>
                            </Grid>
                            <Grid item>
                                <Paper className={classes.paper}>
                                    <ProductCatalogue />
                                </Paper>
                            </Grid>
                        </Grid>
                    </Grid>
                    
                </Grid>
                <Footer />
            </div>
        </Fragment >
    );
}
